import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LimitComponentVisibility } from "go-core/components/LimitComponentVisibility";
import { ItemOrderSource } from "../../../../../../../services/Api/Organization/types";
import { RenderOrderSourceLogo } from "../../../../../../../utils/orders/RenderOrderSourceLogo";

interface Props {
	watchedSources?: ItemOrderSource[];
	handleSetSources: (sources: ItemOrderSource[]) => void;
}

const BlockProductOrderSourcesCard = ({ watchedSources, handleSetSources }: Props) => {
	const finalWatchedSources = watchedSources ?? [];
	const [visible, setVisible] = useState(finalWatchedSources.length > 0);
	const { t } = useTranslation();
	const options: ItemOrderSource[] = [
		ItemOrderSource.POS,
		ItemOrderSource.KIOSK,
		ItemOrderSource.GLOVO,
		ItemOrderSource.UBER,
		ItemOrderSource.WOLT,
		ItemOrderSource.TAKEAWAYV2,
		ItemOrderSource.BOLT,
		ItemOrderSource.GOORDER,
	];

	const handleOptionClick = (option: ItemOrderSource) => {
		const newSources = [...finalWatchedSources];
		if (newSources.includes(option)) {
			const optionIndex = newSources.findIndex((orderType) => orderType === option);
			newSources.splice(optionIndex, 1);
		} else {
			newSources.push(option);
		}

		handleSetSources(newSources);
	};

	const isOptionSelected = (option: ItemOrderSource) => {
		return finalWatchedSources.includes(option);
	};

	const handleChangeVisibility = (value?: boolean) => {
		if (!value) {
			handleSetSources([]);
		} else {
			handleSetSources([...options]);
		}
	};

	return (
		<LimitComponentVisibility
			defaultVisible={visible}
			id="block-product-order-sources"
			legendText={t("modules.item_group.field.restrictions_on_order_sources.title")}
			helpText={t("modules.item_group.field.restrictions_on_order_sources.help_text")}
			isVisibleControl={visible}
			setIsVisibleControl={setVisible}
			handleChange={handleChangeVisibility}
			unlimitedContent={
				<div className="row restrictions-container row-gap-2">
					{options.map((option) => (
						<div className="col-md-6" key={option}>
							<div
								onClick={() => handleOptionClick(option)}
								className={`${isOptionSelected(option) ? "active" : ""}`}
							>
								<RenderOrderSourceLogo source={option} variant="medium" />
								<span>{t(`enums.orders.source.${option}`)}</span>
							</div>
						</div>
					))}
				</div>
			}
		/>
	);
};

export default BlockProductOrderSourcesCard;
